import Polls from '../Polls/Polls';
import './InteractivityLayer.css';
import Reactions from '../Reactions/Reactions';
import { useState } from 'react';

function InteractivityLayer() {
  return (
    <div className="interactivity-layer-container">
      <Reactions />
      <Polls />
    </div>
  );
}

export default InteractivityLayer;
